import { supabase } from "@/integrations/supabase/client";

const sb = supabase as any;

export async function fetchReviewerInbox(reviewerUserId: string) {
  const { data, error } = await sb.rpc('reviewer_list_assignments');
  console.log('reviewer_list_assignments data:', data);

  if (error) {
    console.warn("[fetchReviewerInbox] error:", error);
    return [];
  }

  if (!data?.length) {
    return [];
  }

  return data.map((row: any) => ({
    assessment_id: row.assessment_id,
    org_id: row.org_id,
    org_name: row.org_name ?? "Unknown",
    org_type: row.org_category,
    portfolio_logo: row.portfolio_logo ?? null,
    started_at: row.started_at ?? null,
    submitted_at: row.submitted_at ?? null,
    total_questions: row.total_questions ?? 0,
    answered_count: row.answered_count ?? 0,
    evidence_count: row.total_evidence_items ?? 0,
    created_at: row.created_at,
    status: row.status ?? null,
    reviewer_user_id: reviewerUserId,
    respondent_name: row.respondent_name ?? null,
    respondent_user_id: row.respondent_user_id ?? null,
  }));
}
